<script setup lang="ts">
import { computed, watch } from 'vue'
import { CircleCheck, Circle } from '@lucide/vue'

/*
 * Same 5 regexes as the legacy `UIPasswordValidation` (still used by Account
 * Settings) — this is a restyle for the auth screens, not a rule change.
 */
const props = defineProps<{
  password: string
}>()

const modelValue = defineModel<boolean>({ required: true })

const rules = computed(() => [
  { label: '8-24 characters', valid: /^.{8,24}$/.test(props.password) },
  { label: 'An uppercase letter', valid: /[A-Z]/.test(props.password) },
  { label: 'A lowercase letter', valid: /[a-z]/.test(props.password) },
  { label: 'A number', valid: /[0-9]/.test(props.password) },
  { label: 'One of + = # % ? * $ ! - _', valid: /[+=#%?*$!_-]/.test(props.password) },
])

watch(
  () => props.password,
  () => {
    modelValue.value = rules.value.every(rule => rule.valid)
  },
)
</script>

<template>
  <div
    v-if="password"
    class="flex flex-col gap-1"
  >
    <div
      v-for="rule in rules"
      :key="rule.label"
      class="flex items-center gap-1.5 text-sm font-medium"
      :class="rule.valid ? 'text-success-subtle-foreground' : 'text-muted-foreground'"
    >
      <CircleCheck
        v-if="rule.valid"
        class="size-3.5 shrink-0"
      />
      <Circle
        v-else
        class="size-3.5 shrink-0"
      />
      <span>{{ rule.label }}</span>
    </div>
  </div>
</template>
